import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-760f0570"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Create ")

import InlineSvg from 'vue-inline-svg';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: "link",
      key: "/",
      to: "/"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(InlineSvg), {
          src: "/Camera.svg",
          "aria-label": "Scan QR with Camera"
        })
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      class: "link",
      key: "/scan-image",
      to: "/scan-image"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(InlineSvg), {
          src: "/Image.svg",
          "aria-label": "Scan QR with Camera"
        })
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      class: "link",
      key: "/create",
      to: "/create"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_unref(InlineSvg), {
          src: "/QRCode.svg",
          "aria-label": "Scan QR with Camera"
        })
      ]),
      _: 1
    })
  ]))
}
}

})